import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "ma-0 pa-0"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.filteredDataSources,
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.source'),
      "item-text": "name",
      "item-value": "type",
      "hide-details": "",
      "data-cy": "state_source"
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('changedBindingType');
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemAvatar, [item.icon ? _c(VIcon, {
          attrs: {
            "size": "14",
            "alt": item.name
          }
        }, [_vm._v("fal fa-" + _vm._s(item.icon))]) : item.image ? _c(VAvatar, {
          staticClass: "mx-auto",
          attrs: {
            "size": "14"
          }
        }, [_c('img', {
          staticStyle: {
            "display": "block",
            "margin": "0 auto"
          },
          attrs: {
            "src": item.image,
            "alt": item.name,
            "title": item.name
          }
        })]) : _vm._e()], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(item.name)
          }
        })], 1)];
      }
    }, {
      key: "prepend-inner",
      fn: function () {
        return [_vm.selectedDataSource ? [_vm.selectedDataSource.icon ? _c(VIcon, {
          staticClass: "mr-1",
          attrs: {
            "size": "20",
            "alt": _vm.selectedDataSource.name
          }
        }, [_vm._v("\n              fal fa-" + _vm._s(_vm.selectedDataSource.icon) + "\n            ")]) : _vm.selectedDataSource.image ? _c(VAvatar, {
          staticClass: "mr-1 datasource-icon",
          attrs: {
            "size": "20"
          }
        }, [_c('img', {
          staticStyle: {
            "display": "block",
            "margin": "0 auto"
          },
          attrs: {
            "src": _vm.selectedDataSource.image,
            "alt": _vm.selectedDataSource.name,
            "title": _vm.selectedDataSource.name
          }
        })]) : _vm._e()] : _c('div', {
          staticClass: "mr-1",
          staticStyle: {
            "width": "20px"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.lclModel.properties.binding.type,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.binding, "type", $$v);
      },
      expression: "lclModel.properties.binding.type"
    }
  })], 1)], 1), _vm.selectedDataSource && _vm.selectedDataSource.unavailable ? _c(VAlert, {
    staticClass: "mt-4 mb-2",
    attrs: {
      "type": "info",
      "dense": "",
      "text": "",
      "data-cy": "state_source_unavailable"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedDataSource.unavailableHint) + "\n  ")]) : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'iothub' ? [_c('core-dtwin-state-iothub-edit', {
    ref: "iothubBindingEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "mode": _vm.mode,
      "tenantId": _vm.tenantId
    },
    on: {
      "bridge-binding-changed": e => _vm.$emit('bridge-binding-changed', e),
      "no-permission": e => _vm.$emit('no-permission', e),
      "device-not-found": e => _vm.$emit('device-not-found', e)
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'iothub-aggregate' ? [_c('core-dtwin-state-iothub-aggregate-edit', {
    ref: "iothubBindingEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "mode": _vm.mode,
      "tenantId": _vm.tenantId
    },
    on: {
      "bridge-binding-changed": e => _vm.$emit('bridge-binding-changed', e),
      "no-permission": e => _vm.$emit('no-permission', e)
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'virtual-device' ? [_c('core-dtwin-state-virtual-device-edit', {
    ref: "virtualDeviceBindingEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "mode": _vm.mode,
      "tenantId": _vm.tenantId,
      "dataSources": _vm.filteredDataSources
    },
    on: {
      "bridge-binding-changed": e => _vm.$emit('bridge-binding-changed', e),
      "no-permission": e => _vm.$emit('no-permission', e)
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'virtual-device-aggregate' ? [_c('core-dtwin-state-virtual-device-aggregate-edit', {
    ref: "virtualDeviceBindingEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "mode": _vm.mode,
      "tenantId": _vm.tenantId,
      "otherStates": _vm.otherStates.filter(s => s.id !== _vm.lclModel.id),
      "twinType": _vm.twinType,
      "templateContext": _vm.templateContext,
      "stateDefinition": _vm.stateDefinition,
      "twinModel": _vm.twinModel,
      "dataSources": _vm.filteredDataSources
    },
    on: {
      "bridge-binding-changed": e => _vm.$emit('bridge-binding-changed', e),
      "no-permission": e => _vm.$emit('no-permission', e),
      "stateUpdated": function ($event) {
        return _vm.$emit('stateUpdated');
      }
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'bridge' ? [_c('core-dtwin-state-bridge-edit', {
    ref: "bridgeBindingEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "mode": _vm.mode,
      "bridgeConfigs": _vm.bridgeConfigs,
      "templateContext": _vm.templateContext,
      "vdTenantId": _vm.tenantId
    },
    on: {
      "bridge-binding-changed": e => _vm.$emit('bridge-binding-changed', e),
      "no-permission": e => _vm.$emit('no-permission', e)
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'aggregate' ? [_c('core-dtwin-state-aggregate-edit', {
    ref: "aggregateBindingEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "tenantId": _vm.tenantId,
      "mode": _vm.mode
    },
    on: {
      "aggregatedStateValue": e => _vm.$emit('aggregatedStateValue', e)
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'timeseries-aggregate' ? [_c('core-dtwin-state-timeseries-aggregate-edit', {
    ref: "timeseriesAggregateBindingEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "tenantId": _vm.tenantId,
      "templateContext": _vm.templateContext,
      "otherStates": _vm.templateContext ? _vm.otherStates : _vm.otherStates.filter(s => s.id !== _vm.lclModel.id),
      "mode": _vm.mode
    },
    on: {
      "update": function ($event) {
        return _vm.$emit('validate-form');
      }
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'dynamical-data-routing' ? [_c('p', [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.datarouting.text')) + "\n    ")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.datarouting.point1'))
    }
  }), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.datarouting.point2'))
    }
  })] : _vm._e(), _vm.lclModel.properties.binding && _vm.lclModel.properties.binding.type === 'random' ? [_c(VRow, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description my-0 py-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.randomText')))])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.randomMinimum'),
      "rules": _vm.numberRule,
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('validate-form');
      }
    },
    model: {
      value: _vm.lclModel.properties.binding.options.lower,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.binding.options, "lower", $$v);
      },
      expression: "lclModel.properties.binding.options.lower"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.randomMaximum'),
      "rules": _vm.numberRule,
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('validate-form');
      }
    },
    model: {
      value: _vm.lclModel.properties.binding.options.upper,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.binding.options, "upper", $$v);
      },
      expression: "lclModel.properties.binding.options.upper"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.randomDiscrete'),
      "required": "",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('validate-form');
      }
    },
    model: {
      value: _vm.lclModel.properties.binding.options.discrete,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.binding.options, "discrete", $$v);
      },
      expression: "lclModel.properties.binding.options.discrete"
    }
  })], 1)], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };